import { FC } from 'react';
import { generalBlue } from 'src/app-config';

type propsType = {
    label: string;
    label1?: string;
    setNext: () => void;
    setPrevious: () => void;
};

export const HorizontalSelector: FC<propsType> = ({ label, label1, setNext, setPrevious }) => {
    return (
        <div className={'d-flex justify-content-center'}>
            <button className={'btn btn-secondary rounded-end-0 rounded-start-5 ps-3'}
                onClick={setPrevious}
            >
                Anterior
            </button>
            <div className={'form-control text-center rounded-0 text-white py-1'}
                style={{ backgroundColor: generalBlue, maxWidth: '250px' }}
            >
                <p className={'p-0 m-0'}>{label}</p>
                <p className={'small p-0 m-0'}>{label1}</p>
            </div>
            <button className={'btn btn-secondary rounded-start-0 rounded-end-5 pe-3'}
                onClick={setNext}
            >
                Siguiente
            </button>
        </div>
    );
}
